import useCart from 'modules/cart/util/use-cart';
import React from 'react';
import CartAction from './cart-action';
import {IoDocumentText} from 'react-icons/io5';
import {useNavigate} from 'react-router-dom';

const CartDocument: React.FC = () => {
  const {removeDocument, cart} = useCart();
  const navigate = useNavigate();

  return (
    <CartAction
      {...{
        title: 'CPF ou CNPJ na nota',
        description: cart?.document ?? 'Adicione no comprovante',
        buttonLabel: cart?.document ? 'Remover' : 'Adicionar',
        icon: <IoDocumentText size={28} />,
        onClick: () =>
          cart?.document ? removeDocument() : navigate('add-document'),
      }}
    />
  );
};

export default CartDocument;
